import InfoIcon from 'components/ReusableComponents/Icons/Info'
import ReactTooltip from 'react-tooltip'

import { inPropertyAudiences } from '../constants'
import styles from './AudienceInfoBar.module.scss'

const AudienceInfoBar = ({ audience, audienceSize, totalEligibleForText }) => {
  const audienceData = inPropertyAudiences[audience]

  if (!audienceData) {
    return null
  }

  const Icon = audienceData?.icon
  const title = audienceData?.name

  return (
    <>
      <div className={styles.icon}>
        <Icon />
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{title}</p>
        <p className={styles.description}>
          {audienceSize === 0 && <>No eligable guests</>}
          {audienceSize !== 0 && totalEligibleForText === audienceSize && (
            <>{totalEligibleForText} guests are eligible to text</>
          )}
          {audienceSize !== 0 && totalEligibleForText < audienceSize && (
            <>
              <ReactTooltip />
              {totalEligibleForText} of {audienceSize} guests are eligible to text{' '}
              <span data-tip="Invalid, international and toll-free numbers are not eligible to text">
                <InfoIcon className={styles.infoIcon} />
              </span>
            </>
          )}
        </p>
      </div>
    </>
  )
}

export default AudienceInfoBar
